webpackJsonp([1],{

/***/ "+1xM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Simulado_vue__ = __webpack_require__("XYeF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dca9154_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Simulado_vue__ = __webpack_require__("c2om");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Simulado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dca9154_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Simulado_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "//4H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__("3RCK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30ab30fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__("lT3+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30ab30fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/4kb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/audio-test.9566562.mp3";

/***/ }),

/***/ "0ggY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__ = __webpack_require__("icVI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AudioBox__ = __webpack_require__("FTqs");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['part', 'locked'],
	components: {
		'audio-box': __WEBPACK_IMPORTED_MODULE_1__AudioBox__["a" /* default */]
	},
	methods: {
		respondeu: function respondeu(opcaoId, perguntaId) {
			var pergunta = this.getPerguntaById(perguntaId);
			pergunta.RespostaId = opcaoId;

			if (opcaoId != null) {
				__WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__["a" /* default */].$emit('respondeu', opcaoId, pergunta.Id);
			}
		},
		getPerguntaById: function getPerguntaById(id) {
			var pergunta = this.part.Perguntas.find(function (p) {
				return p.Id == id;
			});

			return pergunta;
		}
	}
});

/***/ }),

/***/ "0pRI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resultado hello-wrapper"},[_c('div',{staticClass:"panel white-tilted-1"},[(_vm.resultado != null)?_c('div',{staticClass:"message"},[_c('div',{staticClass:"icon",class:{ 'aprovado': _vm.resultado.Aprovado, 'reprovado': !_vm.resultado.Aprovado }}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.resultado.Aprovado ? 'Aprovado' : 'Reprovado')+"\n\t\t\t")]),_vm._v(" "),(!_vm.resultado.Aprovado)?_c('div',{staticClass:"text"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.texto)+"\n\t\t\t")]):_vm._e()]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0qcN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"name":_vm.name,"type":"checkbox"},domProps:{"checked":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2EP0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerguntaAudioRelacione_vue__ = __webpack_require__("J74C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_404ae92c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerguntaAudioRelacione_vue__ = __webpack_require__("FNy9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerguntaAudioRelacione_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_404ae92c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerguntaAudioRelacione_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3RCK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__ = __webpack_require__("icVI");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['parts', 'selected'],

	methods: {
		changePart: function changePart(ordem) {
			this.$emit('changed', ordem);
		}
	}
});

/***/ }),

/***/ "3vU4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Instructions_vue__ = __webpack_require__("j2vA");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['simulado'],
	mounted: function mounted() {
		$(this.$el).find(".cpf").mask('000.000.000-00');
	},
	data: function data() {
		return {
			instructionsVisible: false
		};
	},

	methods: {
		showInstructions: function showInstructions() {
			this.instructionsVisible = true;
		}
	},
	computed: {
		textoDuracao: function textoDuracao() {
			var horas = Math.ceil(this.simulado.SimuladoTempoTotal / 60);

			if (horas == 1) return horas + " hora";

			return horas + " horas";
		}
	},
	components: {
		'instructions': __WEBPACK_IMPORTED_MODULE_0__Instructions_vue__["a" /* default */]
	}
});

/***/ }),

/***/ "40gP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function validate(token, ref) {
	return token === getToken(ref);
}

function getToken(ref) {
	return btoa(ref);
}

/* harmony default export */ __webpack_exports__["a"] = ({ validate: validate });

/***/ }),

/***/ "5fI7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingBar_vue__ = __webpack_require__("9Anc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41c3d018_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingBar_vue__ = __webpack_require__("qkJL");
function injectStyle (ssrContext) {
  __webpack_require__("b1MX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41c3d018"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41c3d018_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6A3X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6fM9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Relogio_vue__ = __webpack_require__("cZAR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63ae8ac6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Relogio_vue__ = __webpack_require__("NXT4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Relogio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63ae8ac6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Relogio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7kNO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Acessos_vue__ = __webpack_require__("GY6g");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f919aed4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Acessos_vue__ = __webpack_require__("Gtkx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Acessos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f919aed4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Acessos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7y66":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Start__ = __webpack_require__("lqIt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Pergunta__ = __webpack_require__("xc3X");
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['part', 'locked'],

	computed: {
		comp: function comp() {

			if (this.locked) {
				return 'pergunta';
			}

			if (this.part.EscutouAudio) {
				return 'pergunta';
			} else {
				if (this.started) {
					return 'pergunta';
				}
				return 'start';
			}
		}
	},

	data: function data() {
		return {
			partId: null,
			started: false
		};
	},
	mounted: function mounted() {
		this.partId = this.part.PartId;
	},


	watch: {
		part: function part() {
			if (this.partId !== this.part.PartId) {
				this.started = this.part.EscutouAudio;
			}
		}
	},

	components: {
		'start': __WEBPACK_IMPORTED_MODULE_0__Start__["a" /* default */],
		'pergunta': __WEBPACK_IMPORTED_MODULE_1__Pergunta__["a" /* default */]
	}

});

/***/ }),

/***/ "82HX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox"},[_c('div',{staticClass:"wrapper"},[_c('input',{attrs:{"name":_vm.name,"disabled":_vm.disabled,"type":"radio"},domProps:{"checked":_vm.checked}})]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8PHq":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "8WAG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Anc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__ = __webpack_require__("icVI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			show: false
		};
	},
	mounted: function mounted() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__["a" /* default */].$on('loading', function (l) {
			_this.show = l;
		});
	}
});

/***/ }),

/***/ "9DLF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Check_vue__ = __webpack_require__("bmF5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5edcff1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Check_vue__ = __webpack_require__("0qcN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Check_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5edcff1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Check_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BOjr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__ = __webpack_require__("icVI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_NextButton__ = __webpack_require__("KM2V");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['part', 'comEnunciado', 'large', 'locked'],

	data: function data() {
		return {
			partId: null,
			pergunta: null,
			currentNumber: 1
		};
	},


	watch: {
		part: function part() {
			if (this.part.PartId !== this.partId) {
				this.setByNumber(1);
			}
		}
	},

	computed: {
		opcoes: function opcoes() {
			return this.pergunta.Opcoes;
		}
	},

	mounted: function mounted() {
		this.setByNumber(this.currentNumber);
	},


	methods: {
		respondeu: function respondeu(opcaoId) {
			var opcao = this.pergunta.Opcoes.find(function (e) {
				return e.Id == opcaoId;
			});

			this.pergunta.RespostaId = opcao.opcaoId;
			this.pergunta.Respondeu = true;
			__WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__["a" /* default */].$emit('respondeu', opcaoId, this.pergunta.Id);
			this.$emit('respondeu', opcao, this.currentNumber);
		},
		setByNumber: function setByNumber(i) {
			this.pergunta = this.part.Perguntas[i - 1];
			this.partId = this.part.PartId;
			this.currentNumber = i;
		},
		next: function next() {
			if (this.hasNext()) {
				var next = this.currentNumber + 1;
				this.setByNumber(next);
				this.$emit('page-changed', next);
			} else {
				__WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__["a" /* default */].$emit('next.part');
			}
		},
		previous: function previous() {
			if (this.hasPrevious()) {
				var prev = this.currentNumber - 1;
				this.setByNumber(prev);
				this.$emit('page-changed', prev);
			} else {
				__WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__["a" /* default */].$emit('previous.part');
			}
		},
		hasNext: function hasNext() {
			return this.currentNumber < this.part.Perguntas.length;
		},
		hasPrevious: function hasPrevious() {
			return this.currentNumber > 1;
		}
	},
	components: {
		'next': __WEBPACK_IMPORTED_MODULE_1__ui_NextButton__["a" /* default */]
	}
});

/***/ }),

/***/ "C5pg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CM9Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__ = __webpack_require__("dJ4T");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_219512cd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__("xQSp");
function injectStyle (ssrContext) {
  __webpack_require__("pvQ0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-219512cd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_219512cd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Cnp/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnswerBox__ = __webpack_require__("kxXa");
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['part', 'locked'],
	components: {
		'answer-box': __WEBPACK_IMPORTED_MODULE_0__AnswerBox__["a" /* default */]
	}
});

/***/ }),

/***/ "DaL9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__ = __webpack_require__("icVI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['value', 'text', 'name', 'checked', 'disabled', 'pergunta'],

	data: function data() {
		return {
			check: {}
		};
	},


	watch: {
		disabled: function disabled() {
			if (!this.disabled) {
				this.check.iCheck('enable');
			} else {
				this.check.iCheck('disable');
			}
		}
	},

	mounted: function mounted() {
		var _this = this;

		this.check = $(this.$el).find("input");

		this.check.iCheck({
			radioClass: 'iradio-pink'
		});

		$(this.$el).find(".text").click(function () {
			if (!_this.disabled) {
				_this.check.iCheck('check');
			}
		});

		this.check.on('ifChecked', function () {
			if (!_this.disabled) {
				var perguntaId = null;

				if (_this.pergunta !== undefined) {
					perguntaId = _this.pergunta.Id;
				}

				_this.$emit('checked', _this.value, perguntaId);
			}
		});
	}
});

/***/ }),

/***/ "FNy9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.comp,{tag:"component",attrs:{"locked":_vm.locked,"part":_vm.part},on:{"started":function($event){_vm.started = true}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FTqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AudioBox_vue__ = __webpack_require__("TOEZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_354dfe8f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AudioBox_vue__ = __webpack_require__("INJj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AudioBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_354dfe8f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AudioBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GY6g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['total', 'maximo']
});

/***/ }),

/***/ "Gtkx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"acesso-widget"},[_c('div',{staticClass:"label"},[_vm._v("Access count")]),_vm._v(" "),_c('div',{staticClass:"count"},[_c('span',{staticClass:"total"},[_vm._v(_vm._s(_vm.total))]),_vm._v(" / "),_c('span',{staticClass:"max"},[_vm._v(_vm._s(_vm.maximo))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GvoL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Resultado_vue__ = __webpack_require__("xzWa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0ad060c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Resultado_vue__ = __webpack_require__("0pRI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Resultado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0ad060c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Resultado_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H8Ww":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__ = __webpack_require__("icVI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audio_sound_manager_js__ = __webpack_require__("UItH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_audio_test_mp3__ = __webpack_require__("/4kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_audio_test_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_audio_test_mp3__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['simulado'],
	data: function data() {
		return {
			testouAudio: false,
			audio: null
		};
	},
	mounted: function mounted() {
		this.audio = this.makeAudio();
	},

	computed: {
		tempoParaFazer: function tempoParaFazer() {
			return Math.ceil(this.simulado.SimuladoTempoTotal / 60);
		},
		canStart: function canStart() {
			return this.testouAudio;
		}
	},
	methods: {
		play: function play() {
			this.audio.play();
		},
		start: function start() {
			if (this.canStart) {
				__WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__["a" /* default */].$emit('started');
			}
		},
		makeAudio: function makeAudio() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_1__audio_sound_manager_js__["a" /* default */].destroySound('audioTeste');
			return __WEBPACK_IMPORTED_MODULE_1__audio_sound_manager_js__["a" /* default */].createSound({
				id: 'audioTeste',
				url: __WEBPACK_IMPORTED_MODULE_2__assets_audio_test_mp3___default.a
			});
		}
	}
});

/***/ }),

/***/ "Hhz8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel white-square-1"},[_c('div',{staticClass:"widgets-header"},[_c('relogio',{attrs:{"locked":_vm.locked,"restante":_vm.simulado.TempoRestante}}),_vm._v(" "),_c('acessos',{attrs:{"total":_vm.simulado.TotalAcessos,"maximo":_vm.simulado.SimuladoMaximoDeAcessos}})],1),_vm._v(" "),_c('div',{staticClass:"background"}),_vm._v(" "),_c('div',{staticClass:"body"},[_c('breadcrumb',{attrs:{"parts":_vm.simulado.Parts,"selected":_vm.selectedPart},on:{"changed":_vm.changeSelected}}),_vm._v(" "),_c('div',{staticClass:"part-wrapper"},[_c(_vm.tipoPart,{key:_vm.part.PartId,tag:"component",attrs:{"locked":_vm.locked,"part":_vm.part}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I15n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"instruc hello-wrapper"},[_c('div',{staticClass:"panel white-tilted-1"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"left"},[_c('h1',{staticClass:"heading"},[_vm._v("\n\t\t\t\t\tInstruções\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"icons"},[_c('div',{staticClass:"icon tp"},[_c('span',{staticClass:"texto"},[_vm._v("Tempo de prova")]),_vm._v(" "),_c('div',[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.tempoParaFazer)+"h\n\t\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"icon cp"},[_c('span',{staticClass:"texto"},[_vm._v("Conclua a prova até")]),_vm._v(" "),_c('div',[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.simulado.DiaMaximo)+"\n\t\t\t\t\t\t\t"),_c('span',{staticClass:"small"},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.simulado.MesMaximo)+"\n\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"icon ma"},[_c('span',{staticClass:"texto"},[_vm._v("Máximo de acessos à prova")]),_vm._v(" "),_c('div',[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.simulado.SimuladoMaximoDeAcessos)+"\n\t\t\t\t\t\t")])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"boa-sorte"},[_vm._v("\n\t\t\t\t\tBoa sorte!\n\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('h2',[_vm._v("\n\t\t\t\t\tTeste de áudio\n\t\t\t\t")]),_vm._v(" "),_c('p',[_vm._v("\n\t\t\t\t\tUma parte do teste irá utilizar o sistema de áudio. Verifique se o seu sistema de áudio está funcionando corretamente. Você pode realizar este teste clicando no botão abaixo:\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"teste"},[_c('div',{staticClass:"button",on:{"click":_vm.play}}),_vm._v(" "),_c('p',[_vm._v("\n\t\t\t\t\t\tSe você identificar qualquer problema com o áudio, verifique o volume. Se o problema persistir, por favor, entre em contato com a sua unidade do CNA.\n\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('checkbox',{model:{value:(_vm.testouAudio),callback:function ($$v) {_vm.testouAudio=$$v},expression:"testouAudio"}}),_vm._v("\n\t\t\t\t\tMeu áudio está funcionando!\n\t\t\t\t")],1)])]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg",class:{ 'btn-gray': !_vm.canStart, 'btn-pink': _vm.canStart },on:{"click":_vm.start}},[_vm._v("Start\n\t\t")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Leia todas as instruções de cada parte com atenção;")]),_vm._v(" "),_c('li',[_vm._v("Questões não respondidas serão consideradas erradas;")]),_vm._v(" "),_c('li',[_vm._v("Dê preferência a conexão de Internet via cabo e não wifi;")]),_vm._v(" "),_c('li',[_vm._v("Faça o simulado em um computador ou notebook.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IA+h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerguntaMultiplaEscolha_vue__ = __webpack_require__("Cnp/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_538393f9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerguntaMultiplaEscolha_vue__ = __webpack_require__("vcJ/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerguntaMultiplaEscolha_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_538393f9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerguntaMultiplaEscolha_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "INJj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.locked)?_c('div',{staticClass:"audio-box panel gray-small-square-1"},[_c('div',{staticClass:"shadow left"}),_vm._v(" "),_c('div',{staticClass:"shadow top"}),_vm._v(" "),_c('div',{staticClass:"shadow right"}),_vm._v(" "),_c('div',{staticClass:"shadow bottom"}),_vm._v(" "),(_vm.step1.visible)?_c('div',{staticClass:"step-1"},[_c('div',{staticClass:"timer"},[_vm._v("\n\t\t\t"+_vm._s(_vm.counter)+"\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"seconds"},[_vm._v("\n\t\t\tSeconds\n\t\t")])]):_vm._e(),_vm._v(" "),(_vm.step2.visible)?_c('div',{staticClass:"step-2"},[_c('div',{staticClass:"icon",class:{ muted: _vm.part.EscutouAudio }}),_vm._v(" "),(!_vm.part.EscutouAudio)?_c('div',{staticClass:"player"},[_c('div',{staticClass:"time"},[_c('span',{staticClass:"start"},[_vm._v(_vm._s(_vm.player.time))]),_vm._v(" "),_c('span',{staticClass:"end"},[_vm._v(_vm._s(_vm.player.duration))])]),_vm._v(" "),_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"bar",style:({ width: _vm.player.bar + '%' })})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("\n\t\t\t"+_vm._s(_vm.text)+"\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('button',{staticClass:"btn btn-gray previous left",on:{"click":_vm.previous}},[_vm._v("Previous")]),_vm._v(" "),_c('next',{attrs:{"is-last-page":true,"click":_vm.next,"part":_vm.part}})],1)]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J74C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__audio_Start__ = __webpack_require__("lqIt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Pergunta__ = __webpack_require__("QRXf");
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['part', 'locked'],

	computed: {
		comp: function comp() {

			if (this.locked) {
				return 'pergunta';
			}

			if (this.part.EscutouAudio) {
				return 'pergunta';
			} else {
				if (this.started) {
					return 'pergunta';
				}
				return 'start';
			}
		}
	},

	data: function data() {
		return {
			partId: null,
			started: false
		};
	},
	mounted: function mounted() {
		this.partId = this.part.PartId;
	},


	watch: {
		part: function part() {
			if (this.partId !== this.part.PartId) {
				this.started = this.part.EscutouAudio;
			}
		}
	},

	components: {
		'start': __WEBPACK_IMPORTED_MODULE_0__audio_Start__["a" /* default */],
		'pergunta': __WEBPACK_IMPORTED_MODULE_1__Pergunta__["a" /* default */]
	}

});

/***/ }),

/***/ "JAPr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OptionsBox_vue__ = __webpack_require__("zFse");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddd4e5aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OptionsBox_vue__ = __webpack_require__("yFdk");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OptionsBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddd4e5aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OptionsBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K5K5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"answer-box panel gray-small-square-1",class:{ 'lg': _vm.large }},[_c('div',{staticClass:"shadow left"}),_vm._v(" "),_c('div',{staticClass:"shadow top"}),_vm._v(" "),_c('div',{staticClass:"shadow right"}),_vm._v(" "),_c('div',{staticClass:"shadow bottom"}),_vm._v(" "),_c('div',{staticClass:"body"},[(_vm.pergunta != null)?_c('div',{staticClass:"pergunta"},[_c('div',{staticClass:"enunciado"},[_c('span',[_vm._v(_vm._s(_vm.currentNumber))]),_vm._v(" "+_vm._s(_vm.pergunta.Enunciado)+"\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"opcoes"},_vm._l((_vm.opcoesPergunta),function(opcao,index){return _c('div',{staticClass:"opcao",class:{ 'correta': opcao.Correta }},[_c('radio',{key:opcao.Id + _vm.pergunta.Id,attrs:{"disabled":_vm.locked,"checked":_vm.pergunta.RespostaId == opcao.Id,"name":_vm.pergunta.Id,"value":opcao.Id,"text":opcao.Referencia},on:{"checked":_vm.respondeu}})],1)}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('div',{staticClass:"center"},[_c('strong',[_vm._v(_vm._s(this.currentNumber))]),_vm._v(" / "+_vm._s(_vm.part.Perguntas.length)+"\n\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn btn-gray previous left",on:{"click":_vm.previous}},[_vm._v("Previous")]),_vm._v(" "),_c('next',{attrs:{"locked":_vm.locked,"click":_vm.next,"is-last-page":!_vm.hasNext(),"part":_vm.part}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KM2V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NextButton_vue__ = __webpack_require__("PKx/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42ca97b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NextButton_vue__ = __webpack_require__("acvj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NextButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42ca97b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NextButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KQb1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__("PIBq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07181444_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__("ys9h");
function injectStyle (ssrContext) {
  __webpack_require__("OLXx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07181444"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07181444_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KR6H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['value', 'opcoesPart', 'pergunta', 'disabled'],
	data: function data() {
		return {
			opcoes: [],
			selected: null
		};
	},
	mounted: function mounted() {
		this.selected = this.value;
		this.fillOpcoes();
	},


	watch: {
		selected: function selected(v) {
			this.$emit('changed', v, this.pergunta.Id);
		}
	},

	methods: {
		fillOpcoes: function fillOpcoes() {
			var _this = this;

			var opcoes = this.pergunta.Opcoes.map(function (o) {
				return o;
			});
			var refs = opcoes.map(function (o) {
				return o.Referencia;
			});

			this.opcoesPart.forEach(function (o) {
				if (!refs.includes(o.Referencia)) {
					opcoes.push(o);
				}
			});

			this.opcoes = opcoes.sort(function (a, b) {
				return _this.compare(a, b);
			});
		},
		compare: function compare(a, b) {
			var refA = a.Referencia.toUpperCase();
			var refB = b.Referencia.toUpperCase();

			var comparison = 0;
			if (refA > refB) {
				comparison = 1;
			} else if (refA < refB) {
				comparison = -1;
			}
			return comparison;
		}
	}
});

/***/ }),

/***/ "KWBU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus_event_bus_js__ = __webpack_require__("icVI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__audio_AudioBox__ = __webpack_require__("FTqs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Select__ = __webpack_require__("TmZL");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
	props: ['part', 'locked'],
	components: {
		'audio-box': __WEBPACK_IMPORTED_MODULE_2__audio_AudioBox__["a" /* default */]
	},

	methods: {
		selecionou: function selecionou(opcaoId, perguntaId) {
			var pergunta = this.getPerguntaById(perguntaId);
			pergunta.RespostaId = opcaoId;

			if (opcaoId != null) {
				__WEBPACK_IMPORTED_MODULE_1__bus_event_bus_js__["a" /* default */].$emit('respondeu', opcaoId, pergunta.Id);
			}
		},
		getPerguntaById: function getPerguntaById(id) {
			var pergunta = this.part.Perguntas.find(function (p) {
				return p.Id == id;
			});

			return pergunta;
		}
	},

	computed: {
		opcoes: function opcoes() {
			return this.part.Opcoes;
		}
	}
}, 'components', {
	'options-select': __WEBPACK_IMPORTED_MODULE_3__ui_Select__["a" /* default */],
	'audio-box': __WEBPACK_IMPORTED_MODULE_2__audio_AudioBox__["a" /* default */]

}));

/***/ }),

/***/ "Krpm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerguntaPalavra_vue__ = __webpack_require__("iRR3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08560dc5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerguntaPalavra_vue__ = __webpack_require__("Wmqz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerguntaPalavra_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08560dc5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerguntaPalavra_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c550d0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("nW7U");
function injectStyle (ssrContext) {
  __webpack_require__("8WAG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c550d0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N+zf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['simulado'],

	computed: {
		message: function message() {

			if (this.simulado.Bloqueado) {
				return "O seu acesso ao simulado foi bloqueado.";
			}

			if (!this.simulado.PodeIniciar) {
				return "O período de realização do simulado ainda não começou.";
			}

			if (this.simulado.PrazoAcabou) {
				return "O prazo para realização do simulado terminou.";
			}

			if (this.simulado.TempoAcabou) {
				return "Você utilizou todo o tempo disponível para a realização do simulado.";
			}

			if (this.simulado.SuperouLimiteAcessos) {
				return "Você acessou mais do que o limite permitido.";
			}

			return "";
		}
	}
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_Loader__ = __webpack_require__("CM9Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ui_Radio__ = __webpack_require__("pC/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_Check__ = __webpack_require__("9DLF");
__webpack_require__("6A3X");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

window.$ = window.jQuery = __webpack_require__("7t+N");
__webpack_require__("a7jZ");
__webpack_require__("t+Rb");








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<app/>',
  components: {
    'app': __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('loader', __WEBPACK_IMPORTED_MODULE_3__components_ui_Loader__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Radio', __WEBPACK_IMPORTED_MODULE_4__components_ui_Radio__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('checkbox', __WEBPACK_IMPORTED_MODULE_5__components_ui_Check__["a" /* default */]);

/***/ }),

/***/ "NPWA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['part'],

	methods: {
		start: function start() {
			this.$emit("started");
		}
	}
});

/***/ }),

/***/ "NXT4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relogio"},[_c('div',{staticClass:"remaining"},[_vm._v("Remaining time")]),_vm._v(" "),_c('div',{staticClass:"clock",staticStyle:{"height":"50px"}},[_vm._v("\n\t\t"+_vm._s(this.relogio)+"\n\t")]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"labels"},[_c('span',{staticClass:"hr"},[_vm._v("Hour")]),_vm._v(" "),_c('span',{staticClass:"mn"},[_vm._v("Minutes")]),_vm._v(" "),_c('span',{staticClass:"sg"},[_vm._v("Seconds")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OLXx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Onyd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__("3vU4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56fbd0e9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__("V09H");
function injectStyle (ssrContext) {
  __webpack_require__("xLv3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56fbd0e9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56fbd0e9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PIBq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		show: {
			default: false
		},

		callback: {
			default: function _default() {
				return function () {};
			}
		},

		buttons: {
			default: true
		}
	},
	data: function data() {
		return {
			confirm: function confirm() {}
		};
	},

	watch: {
		callback: function callback(v) {
			this.$set(this, 'confirm', v);
		}
	},
	methods: {
		hide: function hide() {
			this.$emit('update:show', false);
		},
		run: function run() {
			this.confirm(this);
		},
		cancel: function cancel() {
			this.$emit('update:show', false);
		}
	}
});

/***/ }),

/***/ "PKx/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domain_store_js__ = __webpack_require__("R65R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus_event_bus_js__ = __webpack_require__("icVI");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['click', 'part', 'disabled', 'isLastPage', 'locked'],
	data: function data() {
		return {
			lastPage: false
		};
	},
	mounted: function mounted() {
		this.lastPage = this.isLastPage;
	},

	methods: {
		onClick: function onClick() {
			if (!this.disabled) {
				if (__WEBPACK_IMPORTED_MODULE_0__domain_store_js__["a" /* default */].ultimaPart === this.part.Ordem && this.lastPage && !this.locked) {
					__WEBPACK_IMPORTED_MODULE_1__bus_event_bus_js__["a" /* default */].$emit('finalizou');
				} else {
					this.click();
				}
			}
		}
	},

	watch: {
		isLastPage: function isLastPage(v) {
			this.lastPage = v;
		}
	},

	computed: {
		visible: function visible() {
			if (this.locked && this.lastPage) return false;
			return true;
		},
		text: function text() {
			return __WEBPACK_IMPORTED_MODULE_0__domain_store_js__["a" /* default */].ultimaPart === this.part.Ordem && this.lastPage && !this.locked ? "Finish" : "Next";
		}
	}
});

/***/ }),

/***/ "Q57e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error hello-wrapper"},[_c('div',{staticClass:"panel white-tilted-1"},[_c('div',{staticClass:"instructions"},[_c('p',[_c('strong',{staticClass:"name"},[_vm._v("Olá "+_vm._s(_vm.simulado.PrimeiroNome)+",")])]),_vm._v(" "),_c('p',[_vm._v("\n\t\t\t\t"+_vm._s(_vm.message)+"\n\t\t\t")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q70n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile"},[_c('h1',[_vm._v("Olá,")]),_vm._v(" "),_c('p',[_vm._v("\n\t\tEste simulado não está disponível para dispositivos móveis.\n\t")]),_vm._v(" "),_c('p',[_vm._v("\n\t\tPara obter a melhor experiência com o simulado do CNA, por favor, utilize um "),_c('strong',[_vm._v("notebook")]),_vm._v(" ou "),_c('strong',[_vm._v("desktop")]),_vm._v(".\n\t")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QRXf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pergunta_vue__ = __webpack_require__("KWBU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc475a38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pergunta_vue__ = __webpack_require__("gisz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pergunta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc475a38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pergunta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R65R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var simulado = {
	ultimaPart: 0
};

/* harmony default export */ __webpack_exports__["a"] = (simulado);

/***/ }),

/***/ "SUJm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-siele.b939483.png";

/***/ }),

/***/ "SwaE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OptionsBox__ = __webpack_require__("JAPr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus_event_bus_js__ = __webpack_require__("icVI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['part', 'locked'],

	data: function data() {
		return {
			partId: null,
			parsedConteudo: '',
			el: null,
			opcoes: []
		};
	},


	watch: {
		part: function part() {
			if (this.part.PartId !== this.partId) {
				this.init();
			}
		}
	},

	mounted: function mounted() {
		this.init();
	},


	methods: {
		init: function init() {
			this.el = $(this.$el);
			this.setOpcoes();
			this.parseConteudo();
			this.fillBlanks();
			this.partId = this.part.PartId;
		},
		respondeu: function respondeu(opcao, index) {
			var blank = this.getBlankByIndex(index + 1);

			if (opcao !== undefined) {
				blank.val(opcao.Id);
			}
		},
		parseConteudo: function parseConteudo() {
			var _this = this;

			this.parsedConteudo = this.part.PartConteudo.replace(/\{\((.+?)\)\}/g, function (m, c) {
				return _this.makeSelect(c).prop('outerHTML');
			});

			this.el.find('.conteudo').html(this.parsedConteudo);
			var that = this;

			this.el.find('[data-index]').change(function () {

				var id = $(this).val();

				if (id == '') return;

				var index = parseInt($(this).attr('data-index'));
				var opcao = that.getOpcaoByOpcaoPartId(id);

				var pergunta = that.part.Perguntas[index - 1];

				if (opcao !== undefined) {
					pergunta.RespostaId = opcao.Id;
					pergunta.Respondeu = true;
					__WEBPACK_IMPORTED_MODULE_1__bus_event_bus_js__["a" /* default */].$emit('respondeu', opcao.Id, pergunta.Id);
				} else {
					pergunta.RespostaId = id;
					pergunta.Respondeu = true;
					__WEBPACK_IMPORTED_MODULE_1__bus_event_bus_js__["a" /* default */].$emit('respondeu', id, pergunta.Id);
				}
			});
		},
		makeSelect: function makeSelect(index) {
			var select = $("<select></select>");
			select.attr('data-index', index);
			select.addClass('select embbedded pink');

			var defOption = $('<option></option>');
			defOption.text('-');
			defOption.attr('value', '');
			select.append(defOption);

			this.part.Opcoes.forEach(function (el) {
				var option = $('<option></option>');
				option.attr('value', el.Id);
				option.text(el.Referencia);
				select.append(option);
			});

			return select;
		},
		setOpcoes: function setOpcoes() {
			this.opcoes = this.part.Perguntas.map(function (el) {
				return el.Opcoes[0];
			});
		},
		getOpcaoByReferencia: function getOpcaoByReferencia(referencia) {
			return this.opcoes.find(function (el) {
				return el.Referencia === referencia;
			});
		},
		getOpcaoByOpcaoPartId: function getOpcaoByOpcaoPartId(id) {
			var opcao = this.getOpcaoPartById(id);

			if (opcao !== undefined) {
				var opcaoPart = this.getOpcaoByReferencia(opcao.Referencia);
				return opcaoPart;
			}

			return undefined;
		},
		getOpcaoPartByReferencia: function getOpcaoPartByReferencia(referencia) {
			return this.part.Opcoes.find(function (el) {
				return el.Referencia === referencia;
			});
		},
		getOpcaoPartById: function getOpcaoPartById(id) {
			return this.part.Opcoes.find(function (el) {
				return el.Id == id;
			});
		},
		getOpcaoById: function getOpcaoById(id) {
			return this.opcoes.find(function (el) {
				return el.Id == id;
			});
		},
		getOpcaoPartByOpcaoId: function getOpcaoPartByOpcaoId(id) {
			var opcao = this.getOpcaoById(id);

			if (opcao !== undefined) {
				var opcaoPart = this.getOpcaoPartByReferencia(opcao.Referencia);
				return opcaoPart;
			}

			return undefined;
		},
		fillBlanks: function fillBlanks() {
			var _this2 = this;

			this.part.Perguntas.forEach(function (el, i) {
				var opcao = _this2.getOpcaoPartByOpcaoId(el.RespostaId);

				if (opcao === undefined) {
					opcao = _this2.getOpcaoPartById(el.RespostaId);
				}

				_this2.respondeu(opcao, i);
			});
		},
		getBlankByIndex: function getBlankByIndex(index) {
			return this.el.find("[data-index='" + index + "']");
		}
	},

	components: {
		'options-box': __WEBPACK_IMPORTED_MODULE_0__OptionsBox__["a" /* default */]
	}
});

/***/ }),

/***/ "TC+n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audio part"},[_c('div',{staticClass:"enunciado",domProps:{"innerHTML":_vm._s(_vm.part.PartEnunciado)}}),_vm._v(" "),_c('div',{staticClass:"perguntas-container"},_vm._l((_vm.part.Perguntas),function(pergunta,index){return _c('div',{staticClass:"pergunta"},[_c('div',{staticClass:"enunciado"},[_c('span',[_vm._v(_vm._s(index + 1)+")")]),_vm._v(" "+_vm._s(pergunta.Enunciado)+"\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"sub-enunciado"},[_vm._v("\n\t\t\t\t"+_vm._s(pergunta.SubEnunciado)+"\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"opcoes"},_vm._l((pergunta.Opcoes),function(opcao,oi){return _c('div',{staticClass:"opcao",class:{ 'correta': opcao.Correta }},[_c('radio',{attrs:{"disabled":_vm.locked,"checked":pergunta.RespostaId == opcao.Id,"name":index,"pergunta":pergunta,"value":opcao.Id,"text":opcao.Texto},on:{"checked":_vm.respondeu}})],1)}),0)])}),0),_vm._v(" "),_c('audio-box',{attrs:{"part":_vm.part,"locked":_vm.locked}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TE7m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bus_event_bus_js__ = __webpack_require__("icVI");




var axios = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
	baseUrl: 'http://localhost:5815/'
});

axios.defaults.baseURL = "http://simulado.certificacoescna.com.br/";

axios.interceptors.request.use(function (config) {
	__WEBPACK_IMPORTED_MODULE_2__bus_event_bus_js__["a" /* default */].$emit('loading', true);
	return config;
}, function (error) {
	__WEBPACK_IMPORTED_MODULE_2__bus_event_bus_js__["a" /* default */].$emit('loading', false);
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

axios.interceptors.response.use(function (response) {
	__WEBPACK_IMPORTED_MODULE_2__bus_event_bus_js__["a" /* default */].$emit('loading', false);
	return response;
}, function (error) {
	__WEBPACK_IMPORTED_MODULE_2__bus_event_bus_js__["a" /* default */].$emit('loading', false);
	__WEBPACK_IMPORTED_MODULE_2__bus_event_bus_js__["a" /* default */].$emit('request.failed');
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (axios);

/***/ }),

/***/ "TOEZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__audio_sound_manager_js__ = __webpack_require__("UItH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus_event_bus_js__ = __webpack_require__("icVI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_NextButton__ = __webpack_require__("KM2V");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['part', 'locked'],

	data: function data() {
		return {
			interval: null,
			partId: null,
			counter: 3,
			step1: {
				visible: false
			},
			audio: null,
			player: {
				durationMs: 0,
				time: '0:00',
				duration: '',
				bar: 0
			},
			step2: {
				visible: false,
				audioPlaying: false
			}
		};
	},


	computed: {
		text: function text() {
			if (this.step2.audioPlaying) return "";

			return "Answer the questions";
		}
	},

	watch: {
		part: function part() {
			if (this.part.PartId !== this.partId) {
				this.init();
			}
		}
	},

	mounted: function mounted() {

		if (this.locked) return;

		this.init();
	},
	beforeDestroy: function beforeDestroy() {
		this.finish();
	},


	methods: {
		init: function init() {

			if (this.audio != null) {
				this.audio.stop();
			}

			this.player = {
				durationMs: 0,
				time: '0:00',
				duration: '',
				bar: 0
			};

			this.step2 = {
				visible: false,
				audioPlaying: false
			};

			this.counter = this.part.PartTempoLeituraPerguntas;

			this.step1 = {
				visible: false
			};

			this.partId = this.part.PartId;
			if (!this.part.EscutouAudio) {
				this.audio = this.makeAudio();
				this.audio.load();
				this.step2.audioPlaying = true;
				this.firstStep();
			} else {
				this.step2.visible = true;
			}
		},
		firstStep: function firstStep() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1__bus_event_bus_js__["a" /* default */].$emit('audio.started');
			this.step1.visible = true;
			this.interval = setInterval(function () {
				_this.counter--;
				if (_this.counter === 0) {
					_this.secondStep();
				}
			}, 1000);
		},
		next: function next() {
			__WEBPACK_IMPORTED_MODULE_1__bus_event_bus_js__["a" /* default */].$emit('next.part');
		},
		previous: function previous() {
			__WEBPACK_IMPORTED_MODULE_1__bus_event_bus_js__["a" /* default */].$emit('previous.part');
		},
		makeAudio: function makeAudio() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_0__audio_sound_manager_js__["a" /* default */].destroySound(this.part.PartId);
			return __WEBPACK_IMPORTED_MODULE_0__audio_sound_manager_js__["a" /* default */].createSound({
				id: this.part.PartId,
				url: this.part.PartMedia,
				onload: function onload() {
					that.player.duration = that.formatMs(this.duration);
					that.player.durationMs = that.audio.duration;
				}
			});
		},
		playAudio: function playAudio(callback) {
			var that = this;
			this.audio.play({
				whileplaying: function whileplaying() {
					that.player.time = that.formatMs(this.position);
					that.player.bar = this.position / that.player.durationMs * 100;
				},
				onfinish: function onfinish() {
					callback();
				}
			});
		},
		formatMs: function formatMs(millis) {
			var minutes = Math.floor(millis / 60000);
			var seconds = (millis % 60000 / 1000).toFixed(0);
			return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
		},
		finish: function finish() {

			if (!this.part.EscutouAudio) {
				__WEBPACK_IMPORTED_MODULE_1__bus_event_bus_js__["a" /* default */].$emit('audio.played', this.part);
			}

			if (this.audio != null) {
				this.audio.stop();
			}

			this.step2.audioPlaying = false;
			clearInterval(this.interval);
			__WEBPACK_IMPORTED_MODULE_0__audio_sound_manager_js__["a" /* default */].destroySound(this.part.PartId);
		},
		secondStep: function secondStep() {
			var _this2 = this;

			clearInterval(this.interval);
			this.step1.visible = false;
			this.step2.visible = true;
			this.playAudio(function () {
				_this2.finish();
			});
		}
	},
	components: {
		'next': __WEBPACK_IMPORTED_MODULE_2__ui_NextButton__["a" /* default */]
	}
});

/***/ }),

/***/ "TmZL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Select_vue__ = __webpack_require__("KR6H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_949c7ab8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Select_vue__ = __webpack_require__("ojmg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_949c7ab8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TxCl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"answer-box panel gray-small-square-1",class:{ 'lg': _vm.large }},[_c('div',{staticClass:"shadow left"}),_vm._v(" "),_c('div',{staticClass:"shadow top"}),_vm._v(" "),_c('div',{staticClass:"shadow right"}),_vm._v(" "),_c('div',{staticClass:"shadow bottom"}),_vm._v(" "),_c('div',{staticClass:"body"},[(_vm.pergunta != null)?_c('div',{staticClass:"pergunta",class:{ 'sem-enunciado':!_vm.comEnunciado }},[(_vm.comEnunciado)?_c('div',{staticClass:"enunciado"},[_c('span',[_vm._v(_vm._s(_vm.currentNumber))]),_vm._v(" "+_vm._s(_vm.pergunta.Enunciado)+"\n\t\t\t")]):_vm._e(),_vm._v(" "),(!_vm.comEnunciado)?_c('div',{staticClass:"enunciado"},[_c('span',[_vm._v(_vm._s(_vm.currentNumber))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"opcoes"},_vm._l((_vm.opcoes),function(opcao,index){return _c('div',{staticClass:"opcao",class:{ 'correta': opcao.Correta }},[_c('radio',{key:opcao.Id,attrs:{"disabled":_vm.locked,"checked":_vm.pergunta.RespostaId == opcao.Id,"name":_vm.pergunta.Id,"value":opcao.Id,"text":opcao.Texto},on:{"checked":_vm.respondeu}})],1)}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('div',{staticClass:"center"},[_c('strong',[_vm._v(_vm._s(this.currentNumber))]),_vm._v(" / "+_vm._s(_vm.part.Perguntas.length)+"\n\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn btn-gray previous left",on:{"click":_vm.previous}},[_vm._v("Previous")]),_vm._v(" "),_c('next',{attrs:{"locked":_vm.locked,"click":_vm.next,"is-last-page":!_vm.hasNext(),"part":_vm.part}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U3pa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UItH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var soundManager = __webpack_require__("P5lI").soundManager;
var sm = soundManager.setup({
	preferFlash: false
});

/* harmony default export */ __webpack_exports__["a"] = (sm);

/***/ }),

/***/ "V09H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fadeLeft"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.instructionsVisible),expression:"!instructionsVisible"}],staticClass:"hello hello-wrapper"},[_c('div',{staticClass:"panel gray-tilted-1"},[_c('div',{staticClass:"title"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.simulado.SimuladoTituloInicial)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('span',{staticClass:"label"},[_vm._v("Nome do inscrito")]),_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.simulado.NomeCompleto)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('span',{staticClass:"label"},[_vm._v("CPF")]),_vm._v(" "),_c('span',{staticClass:"cpf"},[_vm._v(_vm._s(_vm.simulado.Cpf))])]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('span',{staticClass:"label"},[_vm._v("Data de nascimento")]),_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.simulado.DataNascimento)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('span',{staticClass:"label"},[_vm._v("Email")]),_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.simulado.Email)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('span',{staticClass:"label"},[_vm._v("Escola")]),_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.simulado.Escola)+"\n\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"panel white-tilted-1"},[_c('div',{staticClass:"instructions"},[_c('p',[_c('strong',{staticClass:"name"},[_vm._v("Olá "+_vm._s(_vm.simulado.PrimeiroNome)+",")])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.simulado.SimuladoTextoInicial)}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-pink btn-lg",on:{"click":_vm.showInstructions}},[_vm._v("Next")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fadeLeft"}},[_c('instructions',{directives:[{name:"show",rawName:"v-show",value:(_vm.instructionsVisible),expression:"instructionsVisible"}],attrs:{"simulado":_vm.simulado}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wmqz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"part palavra"},[_c('div',{staticClass:"enunciado",domProps:{"innerHTML":_vm._s(_vm.part.PartEnunciado)}}),_vm._v(" "),_c('div',{staticClass:"conteudo"}),_vm._v(" "),_c('answer-box',{ref:"answerbox",attrs:{"locked":_vm.locked,"part":_vm.part},on:{"respondeu":_vm.respondeu,"page-changed":_vm.pageChanged}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XYeF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_axios_js__ = __webpack_require__("TE7m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__start_Hello_vue__ = __webpack_require__("Onyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_Modal__ = __webpack_require__("KQb1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__result_error_vue__ = __webpack_require__("lA59");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__perguntas_Perguntas_vue__ = __webpack_require__("pXD2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__result_Resultado_vue__ = __webpack_require__("GvoL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bus_event_bus_js__ = __webpack_require__("icVI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__domain_store_js__ = __webpack_require__("R65R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_LoadingBar__ = __webpack_require__("5fI7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__domain_token_parser_js__ = __webpack_require__("40gP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__start_Mobile_vue__ = __webpack_require__("vdxP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({

  props: {
    token: {
      default: null
    }
  },

  data: function data() {
    return {
      loaded: false,
      simulado: null,
      lockedMode: false,
      hasInternetConnection: true,
      failedRequestCount: 0,
      isAudioPlaying: false,
      internetCheckTimeout: null,
      modal: {
        show: false,
        message: '',
        callback: function callback() {}
      },
      aviso: {
        show: false,
        message: ''
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.registerEvents();

    this.getStatus().then(function () {
      _this.checkForLockedMode(_this.simulado.Ref);
      _this.setStore();
      if (_this.simulado.IniciouSimulado) {
        _this.acessou().then(function () {
          _this.loaded = true;
        });
      } else {
        _this.loaded = true;
      }
    });
  },


  computed: {
    hasLogo: function hasLogo() {
      return this.simulado.SimuladoTipo !== 3;
    },
    isCambridgeType: function isCambridgeType() {
      return this.simulado.SimuladoTipo === 1;
    },
    isMobile: function isMobile() {
      return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      );
    },
    currentComponent: function currentComponent() {

      if (this.lockedMode) {
        return "perguntas";
      }

      if (this.simulado.FinalizouSimulado) {
        return "resultado";
      }

      if (this.simulado.Bloqueado) {
        return "error";
      }

      if (this.simulado.SuperouLimiteAcessos) {
        return "error";
      }

      if (this.simulado.TempoAcabou) {
        return "resultado";
      }

      if (!this.simulado.PodeIniciar) {
        return "error";
      }

      if (this.simulado.PrazoAcabou) {
        return "error";
      }

      if (!this.simulado.IniciouSimulado) {
        return "hello";
      }

      if (this.simulado.IniciouSimulado) {
        return "perguntas";
      }

      return "";
    }
  },

  components: {
    mobile: __WEBPACK_IMPORTED_MODULE_10__start_Mobile_vue__["a" /* default */],
    hello: __WEBPACK_IMPORTED_MODULE_1__start_Hello_vue__["a" /* default */],
    perguntas: __WEBPACK_IMPORTED_MODULE_4__perguntas_Perguntas_vue__["a" /* default */],
    error: __WEBPACK_IMPORTED_MODULE_3__result_error_vue__["a" /* default */],
    resultado: __WEBPACK_IMPORTED_MODULE_5__result_Resultado_vue__["a" /* default */],
    loader: __WEBPACK_IMPORTED_MODULE_8__ui_LoadingBar__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_2__ui_Modal__["a" /* default */]
  },

  methods: {
    checkForLockedMode: function checkForLockedMode(cpf) {
      var urlParams = new URLSearchParams(window.location.search);
      var e = urlParams.get('e');
      console.log(e);
      this.lockedMode = __WEBPACK_IMPORTED_MODULE_9__domain_token_parser_js__["a" /* default */].validate(e, cpf);
    },
    registerEvents: function registerEvents() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_6__bus_event_bus_js__["a" /* default */].$on('part.changed', function (prevPart, part) {
        _this2.modal.show = false;
        _this2.pingPart(prevPart);
      });

      this.loadingTimeout = null;
      __WEBPACK_IMPORTED_MODULE_6__bus_event_bus_js__["a" /* default */].$on('loading', function (l) {
        if (_this2.hasInternetConnection) {
          if (l) {
            if (_this2.loadingTimeout == null) {
              _this2.loadingTimeout = setTimeout(function () {
                _this2.showAviso("Aguarde...");
              }, 4000);
            }
          }

          if (!l) {
            _this2.aviso.show = false;
            clearTimeout(_this2.loadingTimeout);
            _this2.loadingTimeout = null;
          }
        }
      });

      __WEBPACK_IMPORTED_MODULE_6__bus_event_bus_js__["a" /* default */].$on('request.failed', function () {
        _this2.failedRequestCount++;
        if (_this2.failedRequestCount === 3) {
          if (_this2.hasInternetConnection) {
            _this2.hasInternetConnection = false;
            _this2.showAviso("Por favor, tente novamente mais tarde.");
          }
        }
      });

      __WEBPACK_IMPORTED_MODULE_6__bus_event_bus_js__["a" /* default */].$on('audio.played', function (prevPart, part) {
        _this2.pingAudio(prevPart);
      });

      __WEBPACK_IMPORTED_MODULE_6__bus_event_bus_js__["a" /* default */].$on('respondeu', function (opcaoId, perguntaId) {

        _this2.respondeu(opcaoId, perguntaId);
      });

      __WEBPACK_IMPORTED_MODULE_6__bus_event_bus_js__["a" /* default */].$on('started', function (opcaoId) {
        _this2.acessou();
      });

      __WEBPACK_IMPORTED_MODULE_6__bus_event_bus_js__["a" /* default */].$on('finalizou', function () {
        _this2.finalizou();
      });

      __WEBPACK_IMPORTED_MODULE_6__bus_event_bus_js__["a" /* default */].$on('relogio.ping', function () {
        _this2.ping();
      });

      __WEBPACK_IMPORTED_MODULE_6__bus_event_bus_js__["a" /* default */].$on('relogio.acabou', function () {
        _this2.finalizar();
      });

      __WEBPACK_IMPORTED_MODULE_6__bus_event_bus_js__["a" /* default */].$on('show.message', function (message, callback) {
        _this2.modal.show = true;
        _this2.modal.message = message;
        _this2.modal.callback = callback;
      });
    },
    setStore: function setStore() {
      __WEBPACK_IMPORTED_MODULE_7__domain_store_js__["a" /* default */].ultimaPart = this.simulado.Parts.length;
    },
    getStatus: function getStatus() {
      var _this3 = this;

      var data = {
        id: this.token
      };

      return __WEBPACK_IMPORTED_MODULE_0__http_axios_js__["a" /* default */].post('status', data).then(function (r) {
        _this3.$set(_this3, 'simulado', r.data);
      });
    },
    updatePart: function updatePart(data) {
      var parts = this.simulado.Parts.map(function (i) {
        if (i.PartId == data.PartId) {
          return data;
        }

        return i;
      });
      this.$set(this.simulado, 'Parts', parts);
    },
    pingAudio: function pingAudio(part) {
      var _this4 = this;

      var data = {
        PartId: part.PartId,
        InscritoId: this.token
      };

      if (this.lockedMode) return;

      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0__http_axios_js__["a" /* default */].post('audio-ping', data).then(function (r) {
          _this4.updatePart(r.data);
        });
      }, 700);
    },
    ping: function ping() {
      var _this5 = this;

      var data = {
        InscritoId: this.token
      };

      if (this.lockedMode) return;

      __WEBPACK_IMPORTED_MODULE_0__http_axios_js__["a" /* default */].post('ping', data).then(function (r) {
        _this5.$set(_this5, 'simulado', r.data);
      });
    },
    pingPart: function pingPart(part) {
      var _this6 = this;

      var data = {
        PartId: part.PartId,
        InscritoId: this.token
      };

      if (this.lockedMode) return;

      __WEBPACK_IMPORTED_MODULE_0__http_axios_js__["a" /* default */].post('ping-part', data).then(function (r) {
        _this6.updatePart(r.data);
      });
    },
    respondeu: function respondeu(opcaoId, perguntaId) {
      var data = {
        OpcaoId: opcaoId,
        InscritoId: this.token,
        PerguntaId: perguntaId
      };

      if (this.lockedMode) return;

      __WEBPACK_IMPORTED_MODULE_0__http_axios_js__["a" /* default */].post('responder', data).then(function (r) {});
    },
    showAviso: function showAviso(message) {
      this.aviso.show = true;
      this.aviso.message = message;
    },
    hideAviso: function hideAviso() {
      this.aviso.show = false;
    },
    acessou: function acessou() {
      var _this7 = this;

      var data = {
        InscritoId: this.token
      };

      return __WEBPACK_IMPORTED_MODULE_0__http_axios_js__["a" /* default */].post('acessou', data).then(function (r) {
        _this7.$set(_this7, 'simulado', r.data);
      });
    },
    finalizar: function finalizar() {
      var _this8 = this;

      var data = {
        InscritoId: this.token
      };

      if (this.lockedMode) return;

      this.modal.show = false;

      return __WEBPACK_IMPORTED_MODULE_0__http_axios_js__["a" /* default */].post('finalizou', data).then(function (r) {
        _this8.$set(_this8, 'simulado', r.data);
      });
    },
    finalizou: function finalizou() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_6__bus_event_bus_js__["a" /* default */].$emit('show.message', "Você deseja realmente finalizar o simulado?", function () {
        _this9.finalizar();
      });
    }
  }
});

/***/ }),

/***/ "YSSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerguntaRelacione_vue__ = __webpack_require__("j9gH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f96e7b1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerguntaRelacione_vue__ = __webpack_require__("zfYE");
function injectStyle (ssrContext) {
  __webpack_require__("iJ18")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f96e7b1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerguntaRelacione_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f96e7b1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerguntaRelacione_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Simulado__ = __webpack_require__("+1xM");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/:token',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Simulado__["a" /* default */],
    props: true
  }]
}));

/***/ }),

/***/ "Yz0B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"part palavra"},[_c('div',{staticClass:"enunciado",domProps:{"innerHTML":_vm._s(_vm.part.PartEnunciado)}}),_vm._v(" "),_c('div',{staticClass:"conteudo"}),_vm._v(" "),_c('options-box',{ref:"optionsbox",attrs:{"large":true,"part":_vm.part}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZaD4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"part"},[_c('div',{staticClass:"enunciado",domProps:{"innerHTML":_vm._s(_vm.part.PartEnunciado)}}),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._v("\n\t\tYou will have "),_c('strong',[_vm._v(_vm._s(_vm.part.PartTempoLeituraPerguntas)+" seconds")]),_vm._v(" to read the questions before the audio starts. The audio will be played twice automatically.\n\t")]),_vm._v(" "),_c('div',{staticClass:"button"},[_c('button',{staticClass:"btn btn-lg btn-pink",on:{"click":_vm.start}},[_vm._v("Start")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aCA/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerguntaLacunaParagrafo_vue__ = __webpack_require__("SwaE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a36a6d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerguntaLacunaParagrafo_vue__ = __webpack_require__("Yz0B");
function injectStyle (ssrContext) {
  __webpack_require__("U3pa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a36a6d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerguntaLacunaParagrafo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a36a6d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerguntaLacunaParagrafo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "acvj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-pink right",class:{disabled: _vm.disabled},attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "apQz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerguntaAudio_vue__ = __webpack_require__("7y66");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91180e68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerguntaAudio_vue__ = __webpack_require__("fuPq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerguntaAudio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91180e68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerguntaAudio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b1MX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bmF5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__ = __webpack_require__("icVI");
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['value', 'name'],

	mounted: function mounted() {
		var _this = this;

		var check = $(this.$el);

		check.iCheck({
			checkboxClass: 'icheck-pink'
		});

		$(this.$el).find(".text").click(function () {
			check.iCheck('check');
		});

		check.on('ifChanged', function () {
			_this.$emit('input', check.is(':checked'));
		});
	}
});

/***/ }),

/***/ "c2om":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isMobile)?_c('div',[(_vm.loaded)?_c('div',{staticClass:"header"},[_c('img',{staticClass:"logo-l",attrs:{"src":__webpack_require__("8PHq"),"alt":""}}),_vm._v(" "),(_vm.isCambridgeType && _vm.hasLogo)?_c('img',{staticClass:"logo-r",attrs:{"src":__webpack_require__("eY+Q"),"alt":"Logo de Cambridge"}}):_vm._e(),_vm._v(" "),(!_vm.isCambridgeType && _vm.hasLogo)?_c('img',{staticClass:"logo-r",attrs:{"src":__webpack_require__("SUJm"),"alt":"Logo do SIELE"}}):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',[_c('loader'),_vm._v(" "),(_vm.loaded)?_c(_vm.currentComponent,{tag:"component",attrs:{"simulado":_vm.simulado,"locked":_vm.lockedMode}}):_vm._e(),_vm._v(" "),_c('modal',{attrs:{"show":_vm.modal.show,"callback":_vm.modal.callback},on:{"update:show":function($event){return _vm.$set(_vm.modal, "show", $event)}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("\n            "+_vm._s(_vm.modal.message)+"\n          ")])])]),_vm._v(" "),_c('modal',{attrs:{"show":_vm.aviso.show,"buttons":false},on:{"update:show":function($event){return _vm.$set(_vm.aviso, "show", $event)}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("\n            "+_vm._s(_vm.aviso.message)+"\n          ")])])])],1)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cZAR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus_event_bus_js__ = __webpack_require__("icVI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['restante', 'locked'],

	data: function data() {
		return {
			moment: null,
			relogio: '',
			seconds: null
		};
	},


	watch: {
		restante: function restante() {
			this.pulse();
		},
		seconds: function seconds(v) {
			if (v != null) {
				if (v == 0) {
					setTimeout(function () {
						__WEBPACK_IMPORTED_MODULE_1__bus_event_bus_js__["a" /* default */].$emit('relogio.ping');
					}, 1000);
				}
			}
		}
	},

	mounted: function mounted() {
		this.moment = __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('day').add(this.restante, 'seconds');
		this.pulse();
		if (!this.locked) {

			this.startClock();
		}
	},


	methods: {
		startClock: function startClock() {
			var _this = this;

			var i = setInterval(function () {
				if (!_this.hasEnded()) {
					_this.pulse();
				} else {
					_this.seconds = _this.moment.second();
					clearInterval(i);
				}
			}, 1000);
		},
		hasEnded: function hasEnded() {
			var start = __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('day');
			return this.moment.isSameOrBefore(start);
		},
		pulse: function pulse() {
			if (this.hasEnded()) {
				this.relogio = "00:00:00";
				__WEBPACK_IMPORTED_MODULE_1__bus_event_bus_js__["a" /* default */].$emit('relogio.acabou');
			} else {
				this.moment.add(-1, 'seconds');
				this.seconds = this.moment.second();
				this.relogio = this.moment.format('HH:mm:ss');
			}
		}
	}
});

/***/ }),

/***/ "dJ4T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__ = __webpack_require__("icVI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		overlay: {
			default: true
		}
	},
	data: function data() {
		return {
			show: false
		};
	},
	mounted: function mounted() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__["a" /* default */].$on('loading', function (l) {
			_this.show = l;
		});
	}
});

/***/ }),

/***/ "eY+Q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-cambridge.d9a8305.png";

/***/ }),

/***/ "fuPq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.comp,{tag:"component",attrs:{"locked":_vm.locked,"part":_vm.part},on:{"started":function($event){_vm.started = true}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gisz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audio-relacione part"},[_c('div',{staticClass:"enunciado",domProps:{"innerHTML":_vm._s(_vm.part.PartEnunciado)}}),_vm._v(" "),_c('div',{staticClass:"conteudo"},[_c('div',{staticClass:"opcoes"},_vm._l((_vm.opcoes),function(opcao,i){return _c('p',[_c('span',[_vm._v(_vm._s(opcao.Referencia))]),_vm._v(" "+_vm._s(opcao.Texto)+"\n\t\t\t")])}),0),_vm._v(" "),_c('div',{staticClass:"respostas"},_vm._l((_vm.part.Perguntas),function(pergunta){return _c('div',[_c('label',[_vm._v(_vm._s(pergunta.Enunciado))]),_vm._v(" "),_c('options-select',{attrs:{"disabled":_vm.locked,"value":pergunta.RespostaId,"opcoes-part":_vm.opcoes,"pergunta":pergunta},on:{"changed":_vm.selecionou}})],1)}),0)]),_vm._v(" "),_c('audio-box',{attrs:{"part":_vm.part,"locked":_vm.locked}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iJ18":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iRR3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnswerBox__ = __webpack_require__("kxXa");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['part', 'locked'],

	data: function data() {
		return {
			partId: null,
			parsedConteudo: '',
			el: null
		};
	},


	watch: {
		part: function part() {
			if (this.part.PartId !== this.partId) {
				this.init();
			}
		}
	},

	mounted: function mounted() {
		this.init();
	},


	methods: {
		init: function init() {
			this.el = $(this.$el);
			this.parseConteudo();
			this.fillBlanks();
			this.partId = this.part.PartId;
		},
		respondeu: function respondeu(opcao, index) {
			var blank = this.getBlankByIndex(index);
			if (opcao !== undefined) {
				blank.html(opcao.Texto);
			}
		},
		parseConteudo: function parseConteudo() {
			this.parsedConteudo = this.part.PartConteudo.replace(/\{\((.+?)\)\}/g, function (m, c) {
				return '<strong class="answer" data-index="' + c + '">_______</strong>';
			});

			this.el.find('.conteudo').html(this.parsedConteudo);
			this.setBlankAsActive(1);
			var that = this;
			this.el.find('[data-index]').click(function () {
				var index = parseInt($(this).attr('data-index'));

				that.$refs.answerbox.setByNumber(index);
				that.setBlankAsActive(index);
			});
		},
		pageChanged: function pageChanged(index) {
			this.setBlankAsActive(index);
		},
		fillBlanks: function fillBlanks() {
			var _this = this;

			var mapped = [];
			this.part.Perguntas.forEach(function (el, i) {
				var opcao = el.Opcoes.find(function (op) {
					return el.RespostaId == op.Id;
				});

				_this.respondeu(opcao, i + 1);
			});
		},
		setBlankAsActive: function setBlankAsActive(index) {
			this.el.find('[data-index]').removeClass('active');
			var blank = this.getBlankByIndex(index);
			blank.addClass('active');
		},
		getBlankByIndex: function getBlankByIndex(index) {
			return this.el.find("[data-index='" + index + "']");
		}
	},

	components: {
		'answer-box': __WEBPACK_IMPORTED_MODULE_0__AnswerBox__["a" /* default */]
	}
});

/***/ }),

/***/ "icVI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

var Bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = (Bus);

/***/ }),

/***/ "ilkf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j2vA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Instructions_vue__ = __webpack_require__("H8Ww");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e12e6ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Instructions_vue__ = __webpack_require__("I15n");
function injectStyle (ssrContext) {
  __webpack_require__("q2QK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e12e6ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Instructions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e12e6ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Instructions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j9gH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RelacioneAnswerBox__ = __webpack_require__("y6Yw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus_event_bus_js__ = __webpack_require__("icVI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['part', 'locked'],

	data: function data() {
		return {
			partId: null,
			opcoes: []
		};
	},


	watch: {
		part: function part() {
			if (this.part.PartId !== this.partId) {}
		}
	},

	mounted: function mounted() {},


	methods: {},

	components: {
		'options-box': __WEBPACK_IMPORTED_MODULE_0__RelacioneAnswerBox__["a" /* default */]
	}
});

/***/ }),

/***/ "jSzW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__ = __webpack_require__("icVI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_NextButton__ = __webpack_require__("KM2V");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['part', 'large', 'locked'],

	data: function data() {
		return {
			partId: null,
			pergunta: null,
			currentNumber: 1
		};
	},


	computed: {
		opcoes: function opcoes() {
			return this.part.Opcoes;
		},
		opcoesPergunta: function opcoesPergunta() {
			return this.getOpcoesPergunta();
		}
	},

	mounted: function mounted() {
		this.setByNumber(1);
	},


	methods: {
		setByNumber: function setByNumber(i) {
			this.pergunta = this.part.Perguntas[i - 1];
			this.partId = this.part.PartId;
			this.currentNumber = i;
		},
		respondeu: function respondeu(opcaoId) {
			this.pergunta.RespostaId = opcaoId;
			this.pergunta.Respondeu = true;
			__WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__["a" /* default */].$emit('respondeu', opcaoId, this.pergunta.Id);
		},
		getOpcoesPergunta: function getOpcoesPergunta() {
			var _this = this;

			var opcoes = this.pergunta.Opcoes;
			var refs = opcoes.map(function (o) {
				return o.Referencia;
			});

			this.opcoes.forEach(function (o) {
				if (!refs.includes(o.Referencia)) {
					opcoes.push(o);
				}
			});

			return opcoes.sort(function (a, b) {
				return _this.compare(a, b);
			});
		},
		next: function next() {
			if (this.hasNext()) {
				var next = this.currentNumber + 1;
				this.setByNumber(next);
				this.$emit('page-changed', next);
			} else {
				__WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__["a" /* default */].$emit('next.part');
			}
		},
		previous: function previous() {
			if (this.hasPrevious()) {
				var prev = this.currentNumber - 1;
				this.setByNumber(prev);
				this.$emit('page-changed', prev);
			} else {
				__WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__["a" /* default */].$emit('previous.part');
			}
		},
		hasNext: function hasNext() {
			return this.currentNumber < this.part.Perguntas.length;
		},
		hasPrevious: function hasPrevious() {
			return this.currentNumber > 1;
		},
		compare: function compare(a, b) {
			var refA = a.Referencia.toUpperCase();
			var refB = b.Referencia.toUpperCase();

			var comparison = 0;
			if (refA > refB) {
				comparison = 1;
			} else if (refA < refB) {
				comparison = -1;
			}
			return comparison;
		}
	},
	components: {
		'next': __WEBPACK_IMPORTED_MODULE_1__ui_NextButton__["a" /* default */]
	}
});

/***/ }),

/***/ "kRfe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "kxXa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnswerBox_vue__ = __webpack_require__("BOjr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14c98550_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnswerBox_vue__ = __webpack_require__("TxCl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnswerBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14c98550_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnswerBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lA59":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_error_vue__ = __webpack_require__("N+zf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_273db7d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_error_vue__ = __webpack_require__("Q57e");
function injectStyle (ssrContext) {
  __webpack_require__("C5pg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-273db7d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_error_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_273db7d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_error_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lJRb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Breadcrumb_vue__ = __webpack_require__("//4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__http_axios_js__ = __webpack_require__("TE7m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bus_event_bus_js__ = __webpack_require__("icVI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__audio_PerguntaAudio_vue__ = __webpack_require__("apQz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lacuna_palavra_PerguntaPalavra_vue__ = __webpack_require__("Krpm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__multipla_escolha_PerguntaMultiplaEscolha__ = __webpack_require__("IA+h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lacuna_paragrafo_PerguntaLacunaParagrafo__ = __webpack_require__("aCA/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__relacione_PerguntaRelacione__ = __webpack_require__("YSSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__relacione_audio_PerguntaAudioRelacione__ = __webpack_require__("2EP0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Relogio__ = __webpack_require__("6fM9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Acessos__ = __webpack_require__("7kNO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['simulado', 'locked'],

	data: function data() {
		return {
			isAudioPlaying: false,
			selectedPart: 1,
			prevPart: 0
		};
	},


	computed: {
		part: function part() {
			return this.getByOrdem(this.selectedPart);
		},
		tipoPart: function tipoPart() {
			if (this.part.PartTipoId == 4) {
				return 'pergunta-audio';
			}
			if (this.part.PartTipoId == 2) {
				return 'pergunta-palavra';
			}
			if (this.part.PartTipoId == 1) {
				return 'pergunta-multipla';
			}
			if (this.part.PartTipoId == 3) {
				return 'lacuna-paragrafo';
			}
			if (this.part.PartTipoId == 5) {
				return 'relacione-audio';
			}
			if (this.part.PartTipoId == 6) {
				return 'relacione';
			}
			return '';
		}
	},

	mounted: function mounted() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_2__bus_event_bus_js__["a" /* default */].$on('next.part', function () {
			_this.triggerNext();
		});

		__WEBPACK_IMPORTED_MODULE_2__bus_event_bus_js__["a" /* default */].$on('previous.part', function () {
			_this.triggerPrevious();
		});

		__WEBPACK_IMPORTED_MODULE_2__bus_event_bus_js__["a" /* default */].$on('audio.started', function () {
			_this.isAudioPlaying = true;
		});

		__WEBPACK_IMPORTED_MODULE_2__bus_event_bus_js__["a" /* default */].$on('audio.played', function () {
			_this.isAudioPlaying = false;
		});
	},


	watch: {
		selectedPart: function selectedPart(ordem, old) {
			this.isAudioPlaying = false;
			this.prevPart = old;
			this.pingPart();
		}
	},

	methods: {
		getByOrdem: function getByOrdem(ordem) {
			return this.simulado.Parts.find(function (e, i, a) {
				return e.Ordem === ordem;
			});
		},
		pingPart: function pingPart() {
			__WEBPACK_IMPORTED_MODULE_2__bus_event_bus_js__["a" /* default */].$emit('part.changed', this.getByOrdem(this.prevPart), this.getByOrdem(this.selectedPart));
		},
		changeSelected: function changeSelected(ordem) {
			var _this2 = this;

			if (!this.isAudioPlaying) {
				this.selectedPart = ordem;
			} else {
				this.showAudioPlayingMessage(function (modal) {
					_this2.selectedPart = ordem;
					modal.hide();
				});
			}
		},
		showAudioPlayingMessage: function showAudioPlayingMessage(callback) {
			__WEBPACK_IMPORTED_MODULE_2__bus_event_bus_js__["a" /* default */].$emit('show.message', 'Mudando de questão você não poderá mais ouvir este áudio. Prosseguir?', callback);
		},
		triggerPrevious: function triggerPrevious() {
			var _this3 = this;

			if (!this.isAudioPlaying) {
				this.previousPart();
			} else {
				this.showAudioPlayingMessage(function (modal) {
					_this3.previousPart();
					modal.hide();
				});
			}
		},
		previousPart: function previousPart() {
			if (this.selectedPart > 1) {
				this.selectedPart = this.selectedPart - 1;
			}
		},
		triggerNext: function triggerNext() {
			var _this4 = this;

			if (!this.isAudioPlaying) {
				this.nextPart();
			} else {
				this.showAudioPlayingMessage(function (modal) {
					_this4.nextPart();
					modal.hide();
				});
			}
		},
		nextPart: function nextPart() {
			if (this.selectedPart < this.simulado.Parts.length) {
				this.selectedPart = this.selectedPart + 1;
			}
		}
	},

	components: {
		'breadcrumb': __WEBPACK_IMPORTED_MODULE_0__Breadcrumb_vue__["a" /* default */],
		'pergunta-audio': __WEBPACK_IMPORTED_MODULE_3__audio_PerguntaAudio_vue__["a" /* default */],
		'pergunta-palavra': __WEBPACK_IMPORTED_MODULE_4__lacuna_palavra_PerguntaPalavra_vue__["a" /* default */],
		'pergunta-multipla': __WEBPACK_IMPORTED_MODULE_5__multipla_escolha_PerguntaMultiplaEscolha__["a" /* default */],
		'relogio': __WEBPACK_IMPORTED_MODULE_9__Relogio__["a" /* default */],
		'acessos': __WEBPACK_IMPORTED_MODULE_10__Acessos__["a" /* default */],
		'lacuna-paragrafo': __WEBPACK_IMPORTED_MODULE_6__lacuna_paragrafo_PerguntaLacunaParagrafo__["a" /* default */],
		'relacione': __WEBPACK_IMPORTED_MODULE_7__relacione_PerguntaRelacione__["a" /* default */],
		'relacione-audio': __WEBPACK_IMPORTED_MODULE_8__relacione_audio_PerguntaAudioRelacione__["a" /* default */]
	}
});

/***/ }),

/***/ "lT3+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"breadcrumb"},_vm._l((_vm.parts),function(part,i){return _c('li',{class:{ 
		active: part.Ordem == _vm.selected,
		visited: part.Ordem != _vm.selected && part.RespondeuPart },on:{"click":function($event){return _vm.changePart(part.Ordem)}}},[_vm._v(_vm._s(part.Ordem))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lqIt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Start_vue__ = __webpack_require__("NPWA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80a5d8ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__ = __webpack_require__("ZaD4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Start_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80a5d8ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nW7U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ojmg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],attrs:{"disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("-")]),_vm._v(" "),_vm._l((_vm.opcoes),function(opcao){return _c('option',{domProps:{"value":opcao.Id}},[_vm._v(_vm._s(opcao.Referencia))])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pC/H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__ = __webpack_require__("DaL9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c2431b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__ = __webpack_require__("82HX");
function injectStyle (ssrContext) {
  __webpack_require__("ilkf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8c2431b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c2431b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pXD2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Perguntas_vue__ = __webpack_require__("lJRb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b8d2c27_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Perguntas_vue__ = __webpack_require__("Hhz8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Perguntas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b8d2c27_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Perguntas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pvQ0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q2QK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qkJL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_c('div',{staticClass:"loader"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vcJ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"part multipla-escolha"},[_c('div',{staticClass:"enunciado",domProps:{"innerHTML":_vm._s(_vm.part.PartEnunciado)}}),_vm._v(" "),_c('div',{staticClass:"conteudo",domProps:{"innerHTML":_vm._s(_vm.part.PartConteudo)}}),_vm._v(" "),_c('answer-box',{attrs:{"locked":_vm.locked,"part":_vm.part,"com-enunciado":true,"large":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vdxP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mobile_vue__ = __webpack_require__("kRfe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_770bace8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mobile_vue__ = __webpack_require__("Q70n");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mobile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_770bace8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mobile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xLv3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xQSp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',[(_vm.overlay)?_c('div',{staticClass:"overlay"}):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xc3X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pergunta_vue__ = __webpack_require__("0ggY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_456b1038_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pergunta_vue__ = __webpack_require__("TC+n");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pergunta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_456b1038_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pergunta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xzWa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_axios_js__ = __webpack_require__("TE7m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus_event_bus_js__ = __webpack_require__("icVI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['simulado'],
	data: function data() {
		return {
			resultado: null
		};
	},


	computed: {
		acertos: function acertos() {
			return this.resultado.Acertos.toString().padStart(2, '0');
		},
		total: function total() {
			return this.resultado.Total.toString().padStart(2, '0');
		},
		texto: function texto() {
			return this.resultado.Aprovado ? '' : 'Procure seu professor ou coordenador pedagógico para maiores informações.';
		}
	},

	methods: {
		getResultado: function getResultado() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1__bus_event_bus_js__["a" /* default */].$emit('loading', true);
			__WEBPACK_IMPORTED_MODULE_0__http_axios_js__["a" /* default */].post('resultado', { id: this.simulado.Id }).then(function (r) {
				_this.$set(_this, 'resultado', r.data);
				__WEBPACK_IMPORTED_MODULE_1__bus_event_bus_js__["a" /* default */].$emit('loading', false);
			});
		},
		getNota: function getNota(nota) {
			if (nota == "B1L") {
				return "B1";
			}

			if (nota == "B1U") {
				return "B1";
			}

			return nota;
		},
		getSubnota: function getSubnota(nota) {
			if (nota == 'B1L') {
				return "(metade inferior) ou abaixo";
			}

			if (nota == 'B1U') {
				return "(metade superior)";
			}
		}
	},

	mounted: function mounted() {
		this.getResultado();
	}
});

/***/ }),

/***/ "y6Yw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelacioneAnswerBox_vue__ = __webpack_require__("jSzW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_818eaca8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelacioneAnswerBox_vue__ = __webpack_require__("K5K5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelacioneAnswerBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_818eaca8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelacioneAnswerBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yFdk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"answer-box options-box panel gray-small-square-1",class:{ 'lg': _vm.large }},[_c('div',{staticClass:"shadow left"}),_vm._v(" "),_c('div',{staticClass:"shadow top"}),_vm._v(" "),_c('div',{staticClass:"shadow right"}),_vm._v(" "),_c('div',{staticClass:"shadow bottom"}),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"opcoes listagem"},_vm._l((_vm.opcoes),function(opcao,index){return _c('div',{staticClass:"opcao",class:{ 'correta': opcao.Correta }},[_c('strong',[_vm._v(_vm._s(opcao.Referencia))]),_vm._v(" "+_vm._s(opcao.Texto)+"\n\t\t\t")])}),0),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('button',{staticClass:"btn btn-gray previous left",on:{"click":_vm.previous}},[_vm._v("Previous")]),_vm._v(" "),_c('next',{attrs:{"locked":false,"click":_vm.next,"is-last-page":!_vm.hasNext(),"part":_vm.part}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ys9h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[(_vm.show)?_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_vm._t("body"),_vm._v(" "),(_vm.buttons)?_c('div',{staticClass:"buttons"},[_c('button',{staticClass:"btn previous btn-gray",on:{"click":_vm.cancel}},[_vm._v("\n\t\t\t\t\t\tVoltar\n\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn btn-pink",on:{"click":_vm.run}},[_vm._v("\n\t\t\t\t\t\tSim\n\t\t\t\t\t")])]):_vm._e()],2)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zFse":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__ = __webpack_require__("icVI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_NextButton__ = __webpack_require__("KM2V");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['part', 'large'],

	data: function data() {
		return {
			partId: null,
			pergunta: null,
			currentNumber: 1
		};
	},


	computed: {
		opcoes: function opcoes() {
			return this.part.Opcoes;
		}
	},

	mounted: function mounted() {},


	methods: {
		next: function next() {
			__WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__["a" /* default */].$emit('next.part');
		},
		previous: function previous() {
			__WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__["a" /* default */].$emit('previous.part');
		},
		hasNext: function hasNext() {
			return false;
		},
		hasPrevious: function hasPrevious() {
			return false;
		}
	},
	components: {
		'next': __WEBPACK_IMPORTED_MODULE_1__ui_NextButton__["a" /* default */]
	}
});

/***/ }),

/***/ "zfYE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"part palavra"},[_c('div',{staticClass:"enunciado",domProps:{"innerHTML":_vm._s(_vm.part.PartEnunciado)}}),_vm._v(" "),_c('div',{staticClass:"conteudo",domProps:{"innerHTML":_vm._s(_vm.part.PartConteudo)}}),_vm._v(" "),_c('options-box',{ref:"optionsbox",attrs:{"large":true,"part":_vm.part}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1be9e4555b4a2e0682c6.js